import './social_profile_view.js.coffee'
Namespace 'Customer.Users'

class Customer.Users.EmailProfileView extends Customer.Users.SocialProfileView
  template: JST['backbone/templates/customer/users/email_profile']
  id: 'email-profile'
